var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"vcp-layer cover-layer"},[_c('img',{attrs:{"alt":"video cover","src":_vm.cover}})])}
var staticRenderFns = []

export { render, staticRenderFns }